import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.injectStyles()
    this.sortable = Sortable.create(this.element, {
      handle: ".match-drag-handle",
      draggable: "tr[data-match-id]",
      animation: 150,
      ghostClass: "sortable-ghost",
      onEnd: () => this.saveOrder()
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  saveOrder() {
    const rows = this.element.querySelectorAll("tr[data-match-id]")
    const ids = Array.from(rows).map((row) => row.dataset.matchId)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ ids: ids })
    }).then((response) => {
      if (response.status === 422) {
        response.json().then((data) => {
          alert(data.error || "Match sorting is locked during the giving phase")
          window.location.reload()
        })
      }
    })
  }

  injectStyles() {
    if (document.getElementById("sortable-matches-styles")) return
    const style = document.createElement("style")
    style.id = "sortable-matches-styles"
    style.textContent = ".sortable-ghost { opacity: 0.4; } .match-drag-handle { cursor: grab; }"
    document.head.appendChild(style)
  }
}
